import Vue from 'vue'
import './index.scss'
import createNode from 'utils/createNode'

class Loading {
    constructor (target) {
        this.$el = createNode('div', {class: 'site-loading'})
        this.$el.insertAdjacentHTML('beforeend', `<div class="wrap">${'<i></i>'.repeat(9)}</div>`)
        this.show(target)
    }
    show (target) {
        if(!this.$el) return

        if(target) {
            let { width, height } = getComputedStyle(target)
            this.$el.setAttribute('style', `width:${width};height:${height};top:${target.offsetTop}px;left:${target.offsetLeft}px;position:absolute;`)
        }

        setTimeout(() => {
            this.$el.classList.add('active')
        }, 150)
    }
    hide () {
        if(!this.$el) return
        this.$el.classList.remove('active')
        setTimeout(() => {
            document.body.removeChild(this.$el)
            delete this.$el
        }, 800)
    }
}

Vue.use({
    install (Vue) {
        Vue.prototype.$loading = window.$loading = (target = null) => {
            try {
                target = document.querySelector(target)
            }catch(err){
                target = null
            }
            return new Loading(target)
        }
    }
})